import { parseAsString, useQueryState } from "nuqs";

import { isValidCreateApplicationDraftId } from "../create-application-page.lib";

const draftIdParser = parseAsString.withOptions({ clearOnDefault: true });

export const useApplicationDraftId = () => {
  const [rawDraftId, setDraftId] = useQueryState("draftId", draftIdParser);
  const draftId = isValidCreateApplicationDraftId(rawDraftId) ? rawDraftId : null;

  return { draftId, setDraftId };
};
